import { render, staticRenderFns } from "./ParcelCultureChangeDialog.vue?vue&type=template&id=5bb00acf&scoped=true"
import script from "./ParcelCultureChangeDialog.vue?vue&type=script&lang=js"
export * from "./ParcelCultureChangeDialog.vue?vue&type=script&lang=js"
import style0 from "./ParcelCultureChangeDialog.vue?vue&type=style&index=0&id=5bb00acf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb00acf",
  null
  
)

export default component.exports